import {
  Avatar,
  Button,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { IBurgerMenuItem } from 'API/Home/burgerMenuItems';
import { burgerMenuItemsPersonalDetailsAndUpdatesSlicer } from 'Config';
import { useAppSelector } from 'Hooks';
import { UnreadNotifications } from 'Images';
import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface IPersonalDetailsAndUpdates {
  closeAccordionTabs: Function;
  closeMenu?: Function;
}
export const PersonalDetailsAndUpdates = ({
  closeAccordionTabs,
  closeMenu,
}: IPersonalDetailsAndUpdates) => {
  const burgerMenuItems = useAppSelector(
    ({ menuItems: { menuItems } }) => menuItems,
  );
  const isReadNotifications = useAppSelector(
    ({ imposter: { isReadNotifications } }) => isReadNotifications,
  );

  const navigate = useNavigate();
  const { pathname } = useLocation();

  const theme = useTheme();
  const isScreenXl = useMediaQuery(theme.breakpoints.up('xl'));

  const memoizedBurgerMenuItems = useMemo(() => {
    return (
      burgerMenuItems &&
      burgerMenuItems
        .slice(0, burgerMenuItemsPersonalDetailsAndUpdatesSlicer)
        .map((menuItem: IBurgerMenuItem, index: number) => {
          return (
            <Button
              key={index}
              sx={{
                width: '50%',
                padding: '12px 0',
                alignItems: 'center',
                gap: '2px',
                flexDirection: 'column',
                borderRadius: 0,
                bgcolor:
                  (pathname.includes('personal-details') &&
                    menuItem.internalLink === 'personal-details') ||
                  (pathname.includes('updates') &&
                    menuItem.internalLink === 'updates')
                    ? 'primary.shade_600'
                    : undefined,
                '&:hover , &:focus': {
                  cursor: 'pointer',
                  bgcolor: 'primary.shade_500',
                },
              }}
              onClick={() => {
                closeAccordionTabs();
                window.scrollTo({ top: 0, behavior: 'smooth' });
                navigate(`/${menuItem.internalLink}`);
                if (!isScreenXl && closeMenu) closeMenu();
              }}
            >
              <Avatar
                alt={''}
                src={
                  menuItem.internalLink === 'updates'
                    ? isReadNotifications
                      ? UnreadNotifications
                      : menuItem.iconUrl
                    : menuItem.iconUrl
                }
                sx={{ width: '24px', height: '24px' }}
              />
              <Typography
                sx={{
                  fontSize: { sm: '20px' },
                  fontWeight: { sm: 400 },
                  color: '#fff',
                  whiteSpace: 'nowrap',
                }}
              >
                {menuItem.description}
              </Typography>
            </Button>
          );
        })
    );
  }, [
    burgerMenuItems,
    navigate,
    pathname,
    closeAccordionTabs,
    isScreenXl,
    closeMenu,
    isReadNotifications,
  ]);

  return (
    <Stack
      direction='row'
      sx={{
        justifyContent: 'center',
        mt: '-15px',
      }}
    >
      {memoizedBurgerMenuItems}
    </Stack>
  );
};
